import { gql, TypedDocumentNode } from "@apollo/client";

import {
  MutationVcsAgentPoolDeleteArgs,
  MutationVcsAgentPoolResetArgs,
  VcsAgentPool,
} from "types/generated";

import { VcsAgentPoolView } from "../types";

type GetVcsAgentPoolData = {
  vcsAgentPool: VcsAgentPoolView;
};

export const GET_VCS_AGENT_POOL: TypedDocumentNode<GetVcsAgentPoolData> = gql`
  query GetVCSAgentPool($vcsAgentPoolId: ID!) {
    vcsAgentPool(id: $vcsAgentPoolId) {
      id
      name
      description
      config
      deleted
      agentConnections {
        id
        metadata
      }
    }
  }
`;

type ResetVcsAgentPoolResponse = Pick<VcsAgentPool, "id" | "name" | "config">;

type ResetVcsAgentPoolData = {
  vcsAgentPoolReset: ResetVcsAgentPoolResponse;
};

export const RESET_VCS_AGENT_POOL: TypedDocumentNode<
  ResetVcsAgentPoolData,
  MutationVcsAgentPoolResetArgs
> = gql`
  mutation ResetVCSAgentPool($id: ID!) {
    vcsAgentPoolReset(id: $id) {
      id
      name
      config
    }
  }
`;

type DeleteVcsAgentPoolResponse = Pick<VcsAgentPool, "id" | "name">;

type DeleteVcsAgentPoolData = {
  vcsAgentPoolDelete: DeleteVcsAgentPoolResponse;
};

export const DELETE_VCS_AGENT_POOL: TypedDocumentNode<
  DeleteVcsAgentPoolData,
  MutationVcsAgentPoolDeleteArgs
> = gql`
  mutation DeleteVCSAgentPool($id: ID!) {
    vcsAgentPoolDelete(id: $id) {
      id
      name
    }
  }
`;
